<div class="attendee-filter">
    <ng-container *ngIf="!limitedMemberList">
        <hr>
        <h2>{{ 'ATTENDEE_FILTER_SORT_BY' | translate }}</h2>
        <ion-item *ngIf="matchingOrderAllowed"
                  class="order ion-no-padding"
                  [ngClass]="{'active': order == 'matching_factor'}"
                  (click)="order='matching_factor';filterChanged()">
            <ion-label>{{ 'ATTENDEE_FILTER_ORDER_MATCHING' | translate }}</ion-label>
        </ion-item>
        <ion-item class="order ion-no-padding"
                  [ngClass]="{'active': order == 'lastname'}"
                  (click)="order='lastname';filterChanged()">
            <ion-label>{{ 'ATTENDEE_FILTER_ORDER_NAME' | translate }}</ion-label>
        </ion-item>
    </ng-container>
    <hr>
    <h2>{{ 'ATTENDEE_FILTER_SHOW_ONLY' | translate }}</h2>
    <ion-item class="global ion-no-padding">
        <ion-checkbox slot="start"
                      (ionChange)="filterChanged()"
                      [(ngModel)]="bookmarks">
        </ion-checkbox>
        <ion-label>{{ 'ATTENDEE_FILTER_SHOW_ONLY_BOOKMARKS' | translate }}</ion-label>
    </ion-item>
    <ion-item class="global ion-no-padding">
        <ion-checkbox slot="start"
                      (ionChange)="filterChanged()"
                      [(ngModel)]="likes">
        </ion-checkbox>
        <ion-label>{{ 'ATTENDEE_FILTER_SHOW_ONLY_LIKES' | translate }}</ion-label>
    </ion-item>
</div>